export const stepValidator = [
  ['fullname'], // STEP 1
  ['fullname', 'project', 'city'], // STEP 2
  ['fullname', 'project', 'city', 'phone'], // STEP 3
  ['fullname', 'project', 'city', 'phone', 'email'], // STEP 4
];
